module.exports = __webpack_public_path__ + "static/media/integral_list_item_03.6c1f4f31.png";